// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__20PJF","productName":"Table_productName__1i32R"};